import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom'

import { Accordion, AccordionSummary, AccordionDetails, Paper, Typography, Stack, MenuItem, Select, InputLabel, FormControl, Button } from "@mui/material"
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { DatePicker } from '@mui/x-date-pickers';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import useFetch from './api/api'
import moment from 'moment'
import config from "./common/Config";

function OperationsLogsDetail() {

	const [operationLogs, setOperationLogs] = useState()
	const [originalOperationsLogs, setOriginalOperationLogs] = useState()
	const [type, setType] = useState('')
	const [status, setStatus] = useState('')

	const [checkboxSelection, setCheckboxSelection] = useState();
	
	const privateFetch = useFetch()
	const { date } = useParams();

	const [initialDate, setInitialDate] = useState(date)
	const [finalDate, setFinalDate] = useState(date)

	useEffect(()=> {
		fetchDatabase()
	},[])

	const fetchDatabase = async () => {
		let options = {
			method : 'POST',
			headers : {
				'content-type' : 'application/json; charset=utf-8',
			},
			body : JSON.stringify({
				initialDate : initialDate,
				finalDate : finalDate
			})
		}
		
		privateFetch(config.apiUrl +"/api/operations", options)
		.then((data) => data.json())
		.then((data) => {
			setOriginalOperationLogs(data)

			let filteredOperations = data
			
			if (type.includes("EARNINGS")) { 
				filteredOperations = filteredOperations.filter(o => o.type === 'EARNINGS' && o.market === type.substring(9,12))
			}
			else if (type !== '') {
				filteredOperations = filteredOperations.filter(o => o.type === type)
			}

			if (status === 'WAR') { 
				filteredOperations = filteredOperations.filter(o => o.status === 'WAI' && o.message !== null)
			}
			else if (status !== '') {
				filteredOperations = filteredOperations.filter(o => o.status === status)
			}

			setOperationLogs(filteredOperations)
		})
	}

	const handleFilter = async () => {
		await fetchDatabase()
	}

	const handleClear = () => {
		setType("")
		setStatus("")
		setOperationLogs(originalOperationsLogs)
	}

	const handleReQueue = () => {
		let options = {
			method : 'POST',
			headers : {
				'content-type' : 'application/json; charset=utf-8',
			},
			body : JSON.stringify({
				updatedIds : checkboxSelection,
			})
		}

		privateFetch(config.apiUrl +"/api/operations/requeue", options)
		.then(fetchDatabase())
	}

    const columns = [
        { field : 'id', headerName : 'Id', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'ticker', headerName : 'Ticker', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
		{ field : 'type', headerName : 'Tipo', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { 
			field : 'status', 
			headerName : 'Status', 
			headerAlign : 'center', 
			align : 'center', 
			sortable : false, 
			disableColumnMenu : true,
			renderCell: (cellValues) => {
				if (cellValues.row.status === 'ERR') {
					return(<ErrorIcon style={{color : 'red'}}/>)
				}
				else if (cellValues.row.message != null && cellValues.row.status === 'WAI') {
					return(<WarningIcon style={{color : 'gold'}}/>)
				}
				else {
					return(<DoneIcon style={{color : 'green'}}/>)
				}
			},
		},
        { field : 'errorCount', headerName : 'Erros', headerAlign : 'center', align : 'center', sortable : false, disableColumnMenu : true},
        { field : 'message', headerName : 'Mensagem', headerAlign : 'center', align : 'left', sortable : false, disableColumnMenu : true, width:800},
	]

	const CustomToolbar = () => {
		return (
			<GridToolbarContainer>
				<Button variant="contained" onClick={() => handleReQueue()}>Re-enfileirar</Button>
			</GridToolbarContainer>
		);
	}

	if (operationLogs === undefined)  {
		return <h1>loading...</h1>;
	}
	return(
		<Paper sx={{marginLeft: 2, marginRight : 4}}>
			<Stack spacing={2}>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1a-content"
						id="panel1a-header"
						>
						<Typography>Filtros</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<Stack spacing={2} direction={"row"} alignItems={"center"}>
							<DatePicker 
								format="DD/MM/YYYY"
								name="dataInit" 
								label="Data Inicial" 
								sx={{width:200,}} 
								value={moment(initialDate)}
								onChange={(value) => setInitialDate(value)}
							/>
							<DatePicker 
								format="DD/MM/YYYY"
								name="dataInit" 
								label="Data Final" 
								sx={{width:200,}} 
								value={moment(finalDate)}
								onChange={(value) => setFinalDate(value)}
							/>							
							<FormControl  sx={{minWidth: 200}}>
								<InputLabel id="select-tipo-label">Tipo</InputLabel>
								<Select
									labelId="select-tipo-label"
									id="select-tipo"
									label="Tipo"
									value={type}
									defaultValue={""}
									onChange={(event) => setType(event.target.value)}
									>
									<MenuItem value={""}>-- Selecione --</MenuItem>
									<MenuItem value={"EARNINGS_BR"}>Dividendos BR</MenuItem>
									<MenuItem value={"EARNINGS_US"}>Dividendos US</MenuItem>
									<MenuItem value={"ACAO"}>Ações</MenuItem>
									<MenuItem value={"STOCK"}>Stocks</MenuItem>

								</Select>	
							</FormControl>
					
							<FormControl sx={{minWidth: 200}}>
								<InputLabel id="select-status-label">Status</InputLabel>
								<Select
									labelId="select-status-label"
									id="select-status"
									label="Status"
									value={status}
									defaultValue={""}
									onChange={(event) => setStatus(event.target.value)}
									>
									<MenuItem value={""}>-- Selecione --</MenuItem>
									<MenuItem value={"PRC"}>Sucesso</MenuItem>
									<MenuItem value={"WAR"}>Atenção</MenuItem>
									<MenuItem value={"ERR"}>Erro</MenuItem>
								</Select>	
							</FormControl>

							<Button variant="contained" onClick={handleFilter}>Filtrar</Button>

							<Button variant="contained" onClick={handleClear}>Limpar</Button>
						</Stack>
					</AccordionDetails>
				</Accordion>
				
				<DataGrid
					getRowId={(row) => row.id} 
					rows={operationLogs}
					columns={columns}
					initialState={{
						pagination: { paginationModel: { pageSize: 20 } },
					}}
					pageSizeOptions={[5, 10, 20]}
					rowHeight={30}
					checkboxSelection
					slots={{
						toolbar: CustomToolbar,
					}}
					onRowSelectionModelChange={(selected) => {
						setCheckboxSelection(selected)
					}}
				/>
			</Stack>
		</Paper>
	)
}



export default OperationsLogsDetail